import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ea5b9854")

_pushScopeId("data-v-ea5b9854")
const _hoisted_1 = { style: {} }
const _hoisted_2 = { style: {"padding":"15px 0"} }
const _hoisted_3 = { class: "current_img1" }
const _hoisted_4 = { class: "side_menu_list1" }
const _hoisted_5 = { class: "project_icon1" }
const _hoisted_6 = {
  class: "fixed",
  style: {"min-height":"calc(100% - 77px)","font-size":"14px"}
}
const _hoisted_7 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_8 = { class: "testMain" }
const _hoisted_9 = { style: {"display":"flex"} }
const _hoisted_10 = { style: {"width":"100%"} }
const _hoisted_11 = {
  style: {"margin-bottom":"20px"},
  class: "flex_betw"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("添加用例")
const _hoisted_13 = { style: {"margin-right":"20px"} }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("当前状态：")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("开始")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("结束")
const _hoisted_17 = { style: {"overflow-y":"auto","max-height":"880px","padding":"20px"} }
const _hoisted_18 = {
  class: "flex_betw",
  style: {"border-bottom":"1px solid #ebeef5","padding-bottom":"20px","margin-bottom":"20px"}
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-edit",
  size: "small"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "el-icon-delete-solid" }, null, -1)
const _hoisted_21 = {
  class: "text_font",
  style: {"text-align":"center","width":"30px"}
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { style: {"height":"32px","line-height":"32px"} }
const _hoisted_24 = { class: "widthBox text_font" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { style: {"height":"32px","line-height":"32px"} }
const _hoisted_27 = { class: "widthBox" }
const _hoisted_28 = {
  key: 0,
  class: "text_font"
}
const _hoisted_29 = { class: "widthBox" }
const _hoisted_30 = {
  key: 0,
  class: "text_font"
}
const _hoisted_31 = { class: "widthBox" }
const _hoisted_32 = {
  key: 0,
  class: "text_font"
}
const _hoisted_33 = { class: "widthBox text_font" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 0,
  style: {"height":"22px"}
}
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "el-icon-delete-solid" }, null, -1)
const _hoisted_37 = { style: {"display":"flex","justify-content":"flex-end","margin-top":"20px"} }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inHover && _ctx.inHover(...args))),
          onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.outHover && _ctx.outHover(...args))),
          style: 'border-bottom: 1px solid #909399;background:' + _ctx.bkg,
          class: "el-submenu__title1"
        }, [
          _createVNode("p", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode("img", {
                src: _ctx.currentProjectIcon,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _createVNode("span", {
              style: 'color:' + _ctx.colorText
            }, _toDisplayString(_ctx.getMyLastProjectName), 5)
          ]),
          _createVNode("div", {
            class: "ab_box",
            style: 'padding:' + _ctx.pad
          }, [
            _withDirectives(_createVNode("ul", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getProjects(_ctx.search), (item) => {
                return (_openBlock(), _createBlock("li", {
                  key: item,
                  style: {"padding":"5px 5px 0 10px","cursor":"pointer"},
                  onClick: ($event: any) => (_ctx.changeProject(item.project.id))
                }, [
                  _createVNode("span", _hoisted_5, [
                    _createVNode("img", {
                      src: item.project.icon,
                      style: {"width":"80%"},
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("span", null, _toDisplayString(item.project.project_name), 1)
                ], 8, ["onClick"]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.rightBox]
            ])
          ], 4)
        ], 36),
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elBtnList, (item) => {
            return (_openBlock(), _createBlock("div", {
              style: {"background":"#5a9cf8","height":"50px","line-height":"50px","margin-bottom":"20px"},
              key: item.id
            }, [
              _createVNode("div", {
                draggable: "true",
                onDragstart: ($event: any) => (_ctx.drag($event, item.action)),
                style: {"color":"#fff","text-align":"center"}
              }, [
                _createVNode("span", {
                  style: {"margin-right":"10px"},
                  class: item.icon
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(item.chinese), 1)
              ], 40, ["onDragstart"])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("div", null, [
                          _createVNode(_component_el_button, {
                            onClick: _ctx.add,
                            size: "mini",
                            type: "primary"
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createVNode("div", null, [
                          _createVNode("span", _hoisted_13, [
                            _hoisted_14,
                            _createVNode("b", {
                              style: 'color: ' + _ctx.caseStatusColor(_ctx.typeStatus(_ctx.status))
                            }, _toDisplayString(_ctx.typeStatus(_ctx.status)), 5)
                          ]),
                          _createVNode(_component_el_button, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.start(0))),
                            size: "mini",
                            type: "primary"
                          }, {
                            default: _withId(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.end(1))),
                            size: "mini",
                            type: "warning"
                          }, {
                            default: _withId(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createVNode("div", _hoisted_17, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.content.case_list, (v, i) => {
                          return (_openBlock(), _createBlock(_component_el_card, {
                            style: {"margin-bottom":"20px"},
                            key: i,
                            class: "flex_box",
                            onDrop: ($event: any) => (_ctx.drop($event, _ctx.id, i, _ctx.index)),
                            onDragover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.allowDrop($event)))
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_18, [
                                _createVNode("div", null, [
                                  _createVNode(_component_el_tooltip, {
                                    effect: "dark",
                                    content: "点击编辑用例名",
                                    placement: "bottom"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_19
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.textShow === false)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 0,
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.textShow = true))
                                      }, "  " + _toDisplayString(v.case_name), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.textShow)
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        onBlur: ($event: any) => (_ctx.textChange(_ctx.content.case_list, i)),
                                        class: "device-form-item",
                                        modelValue: v.case_name,
                                        "onUpdate:modelValue": ($event: any) => (v.case_name = $event),
                                        size: "small"
                                      }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("div", null, [
                                  _createVNode(_component_el_button, {
                                    onClick: ($event: any) => (_ctx.removeBtnALL(_ctx.content.case_list, i)),
                                    size: "mini",
                                    type: "danger"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_20
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ]),
                              _createVNode("div", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(v.action_list, (item, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "flex_betw",
                                    style: {"display":"flex","margin-bottom":"10px"},
                                    key: index
                                  }, [
                                    _createVNode("div", _hoisted_21, [
                                      (index === 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_22, "步骤"))
                                        : _createCommentVNode("", true),
                                      _createVNode("div", _hoisted_23, _toDisplayString(index + 1), 1)
                                    ]),
                                    _createVNode("div", _hoisted_24, [
                                      (index === 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_25, "操作"))
                                        : _createCommentVNode("", true),
                                      _createVNode("div", _hoisted_26, _toDisplayString(_ctx.elBtnList.filter(
                                (v) => v.action === item.action
                              )[0]?.chinese), 1)
                                    ]),
                                    _createVNode("div", _hoisted_27, [
                                      (index === 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_28, "参数1"))
                                        : _createCommentVNode("", true),
                                      _createVNode("div", null, [
                                        _createVNode(_component_el_input, {
                                          placeholder: 
                                _ctx.elBtnList.filter(
                                  (v) => v.action === item.action
                                )[0]?.params[0]?.name_cn
                              ,
                                          class: "device-form-item",
                                          modelValue: item.param1,
                                          "onUpdate:modelValue": ($event: any) => (item.param1 = $event),
                                          size: "small"
                                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_29, [
                                      (index === 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_30, "参数2"))
                                        : _createCommentVNode("", true),
                                      _createVNode("div", null, [
                                        _createVNode(_component_el_input, {
                                          placeholder: 
                                _ctx.elBtnList.filter(
                                  (v) => v.action === item.action
                                )[0]?.params[1]?.name_cn
                              ,
                                          rows: 1,
                                          class: "device-form-item",
                                          modelValue: item.param2,
                                          "onUpdate:modelValue": ($event: any) => (item.param2 = $event),
                                          size: "small"
                                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_31, [
                                      (index === 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_32, "参数3"))
                                        : _createCommentVNode("", true),
                                      _createVNode("div", null, [
                                        _createVNode(_component_el_input, {
                                          placeholder: 
                                _ctx.elBtnList.filter(
                                  (v) => v.action === item.action
                                )[0]?.params[2]?.name_cn
                              ,
                                          class: "device-form-item",
                                          modelValue: item.param3,
                                          "onUpdate:modelValue": ($event: any) => (item.param3 = $event),
                                          size: "small"
                                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_33, [
                                      (index === 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_34, "状态"))
                                        : _createCommentVNode("", true),
                                      _createVNode("div", {
                                        style: 
                              'height:32px;line-height: 32px;color:' +
                              _ctx.typeColor(_ctx.getStatus(item.status))
                            
                                      }, _toDisplayString(_ctx.getStatus(item.status)), 5)
                                    ]),
                                    _createVNode("div", null, [
                                      (index === 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_35))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_el_button, {
                                        onClick: ($event: any) => (_ctx.removeBtn(index, i)),
                                        size: "mini",
                                        type: "danger"
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_36
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onDrop"]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_37, [
                        _createVNode(_component_el_button, {
                          onClick: _ctx.detail,
                          size: "mini",
                          type: "primary"
                        }, {
                          default: _withId(() => [
                            _hoisted_38
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})